import React, { PropsWithChildren } from 'react';

export const Header = ({ children }: Props) => {
    return (
        <>
            {children}
        </>
    );
};

type Props = PropsWithChildren<Record<never, never>>;